import { toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledSelectedFiltersBar = styled.div`
  .selected-filter-button {
    border-radius: ${toRem(8)};
  }
`;
